<div
  class="avatar"
  [class.avatar-primary]="variant === 'primary'"
  [class.avatar-secondary]="variant === 'secondary'"
  [class.avatar-xsmall]="size === 'xsmall'"
  [class.avatar-small]="size === 'small'"
  [class.avatar-large]="size === 'large'"
>
  {{ getInitials(name) }}
</div>
